import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/user/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/user/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/user/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/user/createOrUpdate',
      method: 'post',
      data
    })
  },
  ResetPwd(data) {
    return request({
      url: 'admin/user/resetPwd',
      method: 'post',
      data
    })
  },
  ChangePassword(data) {
    return request({
      url: 'admin/user/changePassword',
      method: 'post',
      data
    })
  },
  export(data) {
    return request({
      url: 'admin/user/export',
      method: 'post',
      data
    })
  },
  Check(data) {
    return request({
      url: 'admin/user/check',
      method: 'post',
      data
    })
  }
}

export default api
